import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Parametro } from 'src/app/models/Parametro';
import { NavModalComponent } from 'src/app/pages/General/nav-modal/nav-modal.component';
import { EntidadService } from 'src/app/services/entidad/entidad.service';
import { openModalMensaje, servicioToken, loadCaptcha01 , uuid} from 'src/app/general/variables';
@Component({
  selector: 'app-modal-terminos',
  templateUrl: './modal-terminos.component.html',
  styleUrls: ['./modal-terminos.component.css']
})
export class ModalTerminosComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalTerminosComponent>,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: Parametro,
              protected entidadService: EntidadService) { }
  url: String = `${servicioToken}`;
  strDscLink1 = '#';
  strDscLink2 = '#';

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;
  urlImagen: any;
  captchaId;

  ngOnInit() {

    this.navModalC.setDatosNavModal2('TÉRMINOS Y CONDICIONES');
    this.loadCaptcha();
  }

  _cancelar() {
    this.dialogRef.close(0);
  }

  _aceptar() {
    /**const valCaptcha = (document.getElementById('textoCaptcha') as HTMLInputElement).value;
    const data = {deviceId: this.captchaId, textoCaptcha: valCaptcha};
    this.entidadService.validarcaptcha(data).subscribe(idata => {
      if (idata != null) {
        if (idata.success) {
          window.localStorage.setItem('tokenfv', 'Bearer ' + idata.token);
          this.dialogRef.close(1);
        } else {
          openModalMensaje('Atención de Denuncias', 'Ingrese el Captcha correctamente, por favor verifique', this.dialog);
          return;
        }
      }
    },
    err => {console.error('Observer got an error: ' + err); },
    () => {});*/

    this.dialogRef.close(1);
  }
  loadCaptcha() {
      this.captchaId = uuid(null, null);
      this.urlImagen = loadCaptcha01(this.url, this.captchaId);
  }




}
